import React from 'react';
import { IComponentStyle } from '@kurtosys/types/componentStyle/IComponentStyle.js';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';
import SeriesPoint from '../SeriesPoint/SeriesPoint.js';

import { ITopSeriesPointConfiguration, ITopSeriesPointProps, ITopSeriesPointState } from './models/index.js';
import {
	TOP_SERIES_POINT_CATEGORY_KEY,
	TOP_SERIES_POINT_COMPONENT_KEY,
	TOP_SERIES_POINT_PARENT_COMPONENT_KEY,
} from './TopSeriesPoint.meta.js';

export class TopSeriesPoint extends ComponentBase<
	ITopSeriesPointProps,
	ITopSeriesPointState,
	ITopSeriesPointConfiguration
> {
	categoryKey = TOP_SERIES_POINT_CATEGORY_KEY;
	componentKey = TOP_SERIES_POINT_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return TOP_SERIES_POINT_PARENT_COMPONENT_KEY;
	}

	constructor(props: ITopSeriesPointProps) {
		super(props);
	}
	render() {
		const { children, position, value, start, end, type, svgProps, imageProps, configuration, ...otherProps } =
			this.props;
		const props = {
			position,
			type,
			svgProps,
			imageProps,
		};

		const style: IComponentStyle = {
			left: `${((value - start) / (end - start)) * 100}%`,
		};

		return (
			<div {...otherProps}>
				<SeriesPoint componentStyle={style} {...props}>
					{children}
				</SeriesPoint>
			</div>
		);
	}
}

export default InjectedStyledComponent(
	observer(TopSeriesPoint),
	TOP_SERIES_POINT_CATEGORY_KEY,
	TOP_SERIES_POINT_PARENT_COMPONENT_KEY,
	[TOP_SERIES_POINT_COMPONENT_KEY],
);
